import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { browserHistory } from "react-router";
import { Button, Row, Col, Panel, FormGroup } from 'react-bootstrap';
import API from "../base/API";
import Auth from "../auth/Auth";
import FormField from "../base/FormField";
import DataSelectTable from "../base/DataSelectTable";
import { translate, languages } from "../base/Translation";

export default class UserNew extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_user: "/user/save/new",
			fetch_fields: "/user/fetch/fields/:role",
			get_brands: "/brand/fetch/all",
		});

		// Experimental: Use passive data instead of state
		// To reduce re-rendering
		this.user = {
			id: 0,
			email: "",
			password: Math.random().toString(36).slice(-8),
			role: 4,
			meta: {
				name: "",
				surname: "",
			},
			brands: []
		};

		this.state = {
			fields: [],
			roles: [
				{ key: 1, value: "UNAUTHORIZED" },
				{ key: 2, value: "Prevádzka / Dealer" },
				{ key: 3, value: "Klient / Importér" },
				{ key: 4, value: "Externý používateľ" },
				{ key: 5, value: "TOPTEST" },
				{ key: 6, value: "Admin" },
				{ key: 7, value: "Super Admin" }
			],
			brands: [],
			tableColumns: [
				{ name: "select", display: "#", sort: true, width: 5 },
				{ name: "name", display: translate("Značka"), sort: true, width: 95 },
			]
		};
	}

	componentDidMount() {
		this.fetch();
	}


	fetch() {
		this.fetchFields(this.user.role);
		this.api.request({
			route: "get_brands",
			success: (response) => {
				this.setState({ brands: response });
			}
		});
	}

	save(evt) {
		this.api.request({
			route: "save_user",
			data: this.user,
			created: (response) => {
				browserHistory.push("/users");
			}
		});
	}

	fetchFields(role) {
		if (parseInt(role, 10) === 0) {
			//this.user.meta = [];			
			this.setState({ fields: [] });
			return;
		}

		this.api.request({
			route: "fetch_fields",
			params: { role: role },
			success: (response) => {
				//this.user.meta = response;
				this.setState({ fields: response });
			}
		});
	}

	onChange(evt) {

		if (evt.target.name === "role") {
			this.fetchFields(evt.target.value);
		}

		let user = this.user;
		user[evt.target.name] = evt.target.value;
		this.user = user;
	}

	onMetaChange(evt) {
		let user = this.user;
		user.meta[evt.target.name] = evt.target.value;
		this.user = user;
	}

	onTableSelect(index, selected) {
		this.user.brands = selected;
		this.setState({ user: this.user });
	}

	render() {
		return (
			<Page>
				<PageHeader title={translate("Údaje používateľa")} />
				<PageBody>
				<Row>
					<Col lg={6}>
						<Panel header={translate("Profil")}>
							{this.state.fields.map(function (field) {
								return <FormField key={field} type="text" title={translate(field)} name={field} value={this.user.meta[field]} onChange={this.onMetaChange.bind(this)} />
							}.bind(this))}
						</Panel>
					</Col>
					<Col lg={6}>
						<Panel header="Prihlasovacie údaje">
							<FormField type="text" title={translate("E-mail")} name="email" value={this.user.email} onChange={this.onChange.bind(this)} />
							<FormField type="password" title={translate("Heslo")} name="password" readOnly={true} value={this.user.password} onChange={this.onChange.bind(this)} />
							<FormField type="select" title={translate("Jazyk")} name="language" value={this.user.language} onChange={this.onChange.bind(this)} options={languages}/>
							<FormField type="select" title={translate("Rola")} name="role" value={this.user.role} onChange={this.onChange.bind(this)} options={this.state.roles} />
						</Panel>
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<Panel header={translate("Značky")}>
							<DataSelectTable
								tableColumns={this.state.tableColumns}
								data={this.state.brands}
								selected={this.user.brands}
								onChange={this.onTableSelect.bind(this)} />
						</Panel>
					</Col>
				</Row>
				<Row>
					<Col lg={12}>
						<FormGroup>
							<Button bsStyle="success" onClick={this.save.bind(this)}>{translate("Uložiť")}</Button>
						</FormGroup>
					</Col>
				</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/user/UserNew.js